import type { LocationEditSchema } from '@repo/schemas/location/locationEdit';
import type { LocationPublic } from '@repo/types/locations';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { LocationKey } from './keys';
import { LocationService } from './locationService';

export function useEditLocation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: LocationEditSchema) => LocationService.editLocation(data).then((response) => response.data),
    onSuccess: (data) => {
      queryClient.setQueryData([LocationKey.LOCATIONS, data.id], (curr: LocationPublic) => {
        return { ...curr, ...data };
      });
      queryClient.setQueryData([LocationKey.LOCATIONS], (curr?: LocationPublic[]) => {
        if (!curr) {
          return;
        }
        return curr.map((l) => (l.id === data.id ? data : l));
      });
      queryClient.invalidateQueries({
        queryKey: [LocationKey.LOCATIONS, data.id],
      });
      queryClient.invalidateQueries({
        queryKey: [LocationKey.LOCATIONS],
      });
    },
  });
}
